import { render, staticRenderFns } from "./warnInfo.vue?vue&type=template&id=0823a050&scoped=true&"
import script from "./warnInfo.vue?vue&type=script&lang=js&"
export * from "./warnInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823a050",
  null
  
)

export default component.exports